/** Catalogue slug for the onboarding welcome slide opened from the learn summary. */
export const LEARN_SUMMARY_WELCOME_SLIDE_SLUG = "welcome";
